import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { loginSchema, UserLoginForm, UserRegisterForm } from '../../../validators/auth.schemas'
import Input from '../../../components/Input'
import Button from '../../../components/Button'
import { Container, ContentCenter, Form, Title } from '../../../components/commons'
import { useNavigate } from 'react-router-dom'
import useToast from '../../../hooks/useToast'
import { api } from '../../../services/api'
import { useAuthStore } from '../../../store/auth'
import { useUserStore } from '../../../store/user'
import axios from 'axios'
import { ResponseError } from '../../../validators/utils.interface'
import { masks } from '../../../utils/masks'
import Avatar from '../../../components/Avatar'
import { useConfigStore } from '../../../store/config'

export interface LoginProps {}

const Login: React.FunctionComponent<LoginProps> = () => {
  const navigate = useNavigate()
  const config = useConfigStore((state) => state).config

  const toast = useToast()
  const [loading, setLoading] = React.useState<boolean>(false)

  const { setToken } = useAuthStore((state) => state)
  const { setUser } = useUserStore((state) => state)

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<UserLoginForm>({
    defaultValues: {
      document: '',
      password: '',
    },
    resolver: yupResolver(loginSchema),
  })

  const handleSubmitLogin = async (formData: UserLoginForm) => {
    try {
      setLoading(true)

      const { data: response } = await api.post('/login', {
        document: masks.unmask(formData.document),
        password: formData.password,
      })

      setUser(response.data)
      setToken(response.token)

      toast.successToast('Login realizado com sucesso !')
    } catch (error) {
      const typedError = error as ResponseError
      if (axios.isAxiosError(error)) {
        toast.errorToast(typedError?.response?.data?.message)
      } else {
        toast.errorToast('Erro ao efetuar o login !')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container>
      {/* <Title>Login</Title> */}
      <ContentCenter>
        <Avatar borderRadius={15} width={150} height={150} source={config?.logo} />
      </ContentCenter>
      <Form onSubmit={handleSubmit(handleSubmitLogin)}>
        <Input
          
          placeholder='Digite seu CPF'
          error={errors?.document}
          control={control}
          label='CPF'
          type='text'
          mask={'cpf'}
          name='document'
        />
        <Input
          placeholder='Digite sua Senha'
          error={errors?.password}
          control={control}
          label='Senha'
          type='password'
          name='password'
        />

        <Button
          label='Entrar'
          loading={loading}
          type='submit'
          fullWidth
          variantType='block'
          color='primary'
        />
        <ContentCenter>
          <Button
            onClick={() => navigate('/forgot')}
            label='Esqueci a Senha'
            variantType='label'
            color='primary'
          />
        </ContentCenter>
        <ContentCenter>
          <Button
            onClick={() => navigate('/register')}
            label='Você não tem uma conta? Cadastrar-se'
            variantType='label'
            color='primary'
          />
        </ContentCenter>
      </Form>
    </Container>
  )
}

export default Login
